export const LOADING = 'LOADING';
export const SUCCEEDED = 'SUCCEEDED';
export const ERROR = 'ERROR';
export const IDLE = 'IDLE';
export const OUTDATED = 'OUTDATED';
